export default __webpack_public_path__ + "static/media/essaim3.8f575860.jpg";